import WarehousePackagesList from "./PackagesList";

export default function WarehouseReadyLastMile() {
  return (
    <WarehousePackagesList
      status="READY_FOR_LAST_MILE_PICKUP"
      title="Ready for Last-Mile Pickup"
      description="Riders can now scan these for last-mile delivery."
    />
  );
}
